import { Tooltip } from "@rentiohq/web-shared/dist/components";
import React from "react";
import { RM_COLORS } from "../rentmatch.colors";
import { BARE_TOOLTIP_TRIGGER_STYLE } from "../tooltipTrigger.styles";

interface IWarningTooltipProps {
  tooltipContent: React.ReactNode;
  size?: number;
}

/**
 * Amber warning triangle (⚠) with a styled Tooltip popup.
 * Uses the same Tooltip component and yellow color palette as the
 * cross-property warning in ApplicationTableRow.
 */
export const WarningTooltip: React.FC<IWarningTooltipProps> = ({
  tooltipContent,
  size = 16,
}) => (
  <Tooltip
    style={BARE_TOOLTIP_TRIGGER_STYLE}
    tooltipContentStyle={{
      backgroundColor: RM_COLORS.yellowBgSoft,
      color: RM_COLORS.gray800,
      border: `1px solid ${RM_COLORS.amberBorder}`,
      padding: "6px 10px",
      borderRadius: "6px",
      fontSize: "12px",
      lineHeight: "1.4",
    }}
    tooltipContent={<div style={{ maxWidth: "240px" }}>{tooltipContent}</div>}
  >
    <span
      style={{
        color: RM_COLORS.amber,
        display: "inline-flex",
        alignItems: "center",
        cursor: "help",
        marginLeft: "5px",
        verticalAlign: "middle",
      }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line
          x1="12"
          y1="9"
          x2="12"
          y2="13"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="12"
          y1="17"
          x2="12.01"
          y2="17"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </span>
  </Tooltip>
);
